import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Row, Col, Icon, Menu } from 'antd';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  selectTeamModal: {
    color: '#262626',
    '& .ant-modal-body': {
      padding: '16px 0px',
      height: '300px',
      overflow: 'auto',
    },
    '& .ant-modal-title': {
      fontSize: `${tokens.fontSize.h1}px`,
      padding: '5px 0px',
    },
  },
  flexRow: {
    display: 'flex',
    alignItems: 'center',
  },
  teamsMenu: {
    borderRight: 'unset',
    '& .ant-menu-item': {
      marginBottom: '0px !important',
      margin: 0,
      padding: '0px 10px',
      height: '30px',
      '&:hover': {
        backgroundColor: '#F7F7F7',
        color: '#262626',
      },
    },
  },
  SelectedTeam: {
    backgroundColor: '#eee',
    '& .ant-menu-item-selected': {
      color: '#000000A6!important',
    },
  },
  checkIcon: {
    color: tokens.colors.primary,
  },
  notSelected: {
    color: 'inherit',
    backgroundColor: 'white!important',
  },
  '& .ant-menu-item-selected': {
    color: '#000000A6!important',
  },
});

class TeamForInquiryAccessModal extends React.Component<any, any> {
  render() {
    const {
      isVisible,
      classes,
      onCancel,
      teams,
      handleTeamSelect,
      teamId,
      bookingAccessTeams,
      isBooking,
    } = this.props;
    return (
      <Modal
        className={classes.selectTeamModal}
        title="Select Team For Inquiry Access"
        visible={isVisible}
        onCancel={onCancel}
        footer={null}
      >
        <Row className={classes.flexRow} style={{ padding: '10px', fontWeight: 600 }}>
          <Col span={4} style={{ textAlign: 'center' }}>
            S.N.
          </Col>
          <Col span={9}>Team Name</Col>
          <Col span={9}>Reference Number</Col>
        </Row>
        <Menu className={classes.teamsMenu}>
          {teams &&
            teams.length &&
            teams.map((team, index) => {
              let isActive = isBooking ? !!bookingAccessTeams[team.id] : teamId === team.id;
              return (
                <Menu.Item
                  key={index}
                  className={isActive ? classes.SelectedTeam : classes.notSelected}
                  onClick={() => handleTeamSelect(team)}
                >
                  <Row className={classes.flexRow} style={{ height: '30px' }}>
                    <Col span={4} style={{ textAlign: 'center' }}>
                      {index + 1}
                    </Col>
                    <Col span={9}>{team.name} </Col>
                    <Col span={9}>{team.reference_number}</Col>
                    <Col span={1}>
                      <Icon
                        type="check"
                        className={classes.checkIcon}
                        style={{ display: isActive ? 'inline' : 'none' }}
                      />
                    </Col>
                  </Row>
                </Menu.Item>
              );
            })}
        </Menu>
      </Modal>
    );
  }
}
export default injectSheet(styles)(TeamForInquiryAccessModal);
